import React, { useContext, useState } from "react"; 
import { Context } from "../contexts/AppContext";

function NewFolderCreateP({ updateData }) {
  const [folderName, setFolderName] = useState("");

  // Contexts
 

  const { value } = useContext(Context);
  const [state, setState] = value;
  const [videoState, setVideoState] = value;

  // Handle input change
  const handleChange = (event) => {
    const newValue = event.target.value;
    setFolderName(newValue);
    updateData(newValue);
  };

  return (
    <div>
      <label
        htmlFor="folder_name"
        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
      >
        New Folder
      </label>

      <div>
        <label
          htmlFor="folder_name"
          className="block mb-2 text-xs font-medium text-gray-300 dark:text-white"
        >
          Folder Name*
        </label>
        <input
          type="text"
          id="folder_name"
          value={folderName}
          onChange={handleChange}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          placeholder="Enter Folder Name"
          required
        />
      </div>
    </div>
  );
}

export default NewFolderCreateP;
